import { render, staticRenderFns } from "./CompilaQuestionarioIrst.vue?vue&type=template&id=67a356fa&"
import script from "./CompilaQuestionarioIrst.vue?vue&type=script&lang=js&"
export * from "./CompilaQuestionarioIrst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports